import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "discount-dialog" }
const _hoisted_2 = { class: "new-discount-section" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wrapper amount" }
const _hoisted_5 = { class: "input-wrapper reason" }
const _hoisted_6 = {
  key: 0,
  class: "existing-discounts-section"
}
const _hoisted_7 = { class: "discounts-list" }
const _hoisted_8 = { class: "discount-info" }
const _hoisted_9 = { class: "discount-amount" }
const _hoisted_10 = { class: "discount-date" }
const _hoisted_11 = {
  key: 0,
  class: "discount-description"
}
const _hoisted_12 = {
  key: 1,
  class: "no-discounts"
}

import { ref } from 'vue'
import { DateTime } from 'luxon'

interface Discount {
  id: string
  amount: number
  reason?: string
  admin_id?: string
  applied_at: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DiscountModal',
  props: {
    visible: { type: Boolean },
    discounts: {},
    processingDiscount: { type: Boolean },
    removingDiscount: { type: Boolean }
  },
  emits: ["update:visible", "apply-discount", "remove-discount"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const discountAmount = ref('')
const discountReason = ref('')

const formatAmount = (amount: number | string | null) => {
  if (amount === null || amount === undefined) return '0.00'
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  if (isNaN(numAmount)) return '0.00'
  return numAmount.toFixed(2)
}

const formatDiscountDate = (dateString: string) => {
  const date = DateTime.fromISO(dateString)
  return date.toFormat('MMM dd, yyyy HH:mm')
}

const handleApplyDiscount = () => {
  if (!discountAmount.value) return

  const discountValue = parseFloat(discountAmount.value)
  if (discountValue <= 0) return

  emit('apply-discount', {
    amount: discountValue,
    reason: discountReason.value,
  })
  discountAmount.value = ''
  discountReason.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    title: "Manage Discounts",
    width: "500px",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event)))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("Cancel")
        ])),
        _: 1,
        __: [9]
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleApplyDiscount,
        loading: _ctx.processingDiscount,
        disabled: !discountAmount.value
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [
          _createTextVNode(" Add Discount ")
        ])),
        _: 1,
        __: [10]
      }, 8, ["loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Add New Discount", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: discountAmount.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((discountAmount).value = $event)),
                placeholder: "0.00",
                type: "number"
              }, {
                prefix: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("₼")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_input, {
                modelValue: discountReason.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((discountReason).value = $event)),
                placeholder: "Reason",
                type: "text"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        (_ctx.discounts.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Applied Discounts", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discounts, (discount) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: discount.id,
                    class: "discount-item"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, "₼" + _toDisplayString(formatAmount(discount.amount)), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(formatDiscountDate(discount.applied_at)), 1),
                      (discount.reason)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(discount.reason), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (_ctx.$emit('remove-discount', discount.id)),
                      loading: _ctx.removingDiscount
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Remove ")
                      ])),
                      _: 2,
                      __: [6]
                    }, 1032, ["onClick", "loading"])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[8] || (_cache[8] = [
              _createElementVNode("p", null, "No discounts applied yet", -1)
            ])))
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})